"use client";
import exampleSoftwareScreenshot from "@/public/pictures/kitchen.png";
import Realm from "@/components/Realm/Realm";
import { FunctionComponent } from "react";
import { scrollFx } from "@/modules/visual/scrollFx";

interface RealmSectionHomeProps {}

const RealmSectionHome: FunctionComponent<RealmSectionHomeProps> = () => {
  return (
    <section
      className="group relative overflow-x-clip py-16"
      {...scrollFx({ trigger: "middle", effect: "revealWidth", band: 0.2 })}
    >
      {/* Animated blue background */}
      <div
        className="
        realm-bg absolute inset-y-0 left-1/2 -translate-x-1/2
        bg-gradient-to-r from-blue-900 via-blue-800 to-indigo-900
        ring-1 ring-white/10
        shadow-[0_30px_120px_-60px_rgba(0,0,0,0.9)]
        transition-[width] duration-700 ease-out
        w-[80%] group-[.is-inview]:w-screen
        rounded-2xl
      "
      />

      {/* Content stays normal + above background */}
      <div className="relative z-10">
        <Realm
          imageSrc={exampleSoftwareScreenshot}
          imageAltText="Screenshot Software"
          isBackgroundColored
          translationKeyTitle="home.realm.title"
          translationDefaultTitle="The next generation of artificial intelligence"
          translationKeyParagraph="home.realm.text"
          translationDefaultParagraph="AI agents don’t just answer questions — they guide customers to the right product using your catalog, your rules, and real stock."
          translationKeyCTA="home.realm.cta"
          translationDefaultCTA="Discover our solution"
          urlCTA="demo"
          displayImage={false}
          highlights={[
            {
              translationKey: "home.realm.b1",
              defaultMessage:
                "Available 24/7: every visitor gets instant answers.",
            },
            {
              translationKey: "home.realm.b2",
              defaultMessage:
                "Beginner to expert: adapts the depth of advice automatically.",
            },
            {
              translationKey: "home.realm.b3",
              defaultMessage:
                "Grounded recommendations: only what you can actually fulfill (stock, variants, constraints).",
            },
            {
              translationKey: "home.realm.b4",
              defaultMessage:
                "Turns “I’m not sure what I need” into a confident recommendation with clear trade-offs.",
            },
            {
              translationKey: "home.realm.b5",
              defaultMessage:
                "Improves conversion by removing doubt right before checkout.",
            },
          ]}
        />
      </div>
    </section>
  );
};

export default RealmSectionHome;
